import Helper from './Helper';

class TeaserHeight {
  constructor() {
    this.teaserArray = [...document.querySelectorAll('.ns-teaser')];
    if (this.teaserArray.length > 0) {
      window.addEventListener("load", () => {
        this.setMinHeight();
      });
      window.addEventListener("resize", () => {
        this.setMinHeight();
      });
    }
  }

  setMinHeight() {
    this.teaserArray.forEach(teaser => {
      const img = teaser.querySelector('.ns-img__img');
      if(img){
        teaser.style.minHeight = img.height+'px';
      }
    });
  }
}

export default TeaserHeight;
